export default "__VITE_ASSET__06b0038e__"